import React, { useEffect, useState } from 'react';

type Media = { width: number; height: number };
const MediaContext = React.createContext<Media>({ width: 0, height: 0 });

type MediaProviderProps = {
  children: JSX.Element;
};
function MediaProvider(props: MediaProviderProps) {
  const { children } = props;
  const [media, setMedia] = useState<Media>({ width: window.document.body.clientWidth, height: window.document.body.clientHeight });

  useEffect(() => {
    window.addEventListener('resize', () => {
      setMedia({
        width: window.document.body.clientWidth,
        height: window.document.body.clientHeight,
      });
    });
    window.addEventListener('load', () => {
      setMedia({
        width: window.document.body.clientWidth,
        height: window.document.body.clientHeight,
      });
    });
    return function cleanup() {
      window.removeEventListener('resize', () => {});
      window.removeEventListener('load', () => {});
    };
  }, []);
  return <MediaContext.Provider value={media}>{children}</MediaContext.Provider>;
}

export { MediaContext };
export default MediaProvider;
